module.exports = __webpack_public_path__ + "static/img/timg.8ba1128.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/timg.jpg
// module id = v3F0
// module chunks = 1